import {Injectable} from '@angular/core';
import {BaseService} from '../base.service';
import {BehaviorSubject, Observable, of} from 'rxjs';
import {HttpClient} from '@angular/common/http';
import {ResponseModel} from '../../models/comons/dto/ResponseModel';
import {PackageResponse} from '../../models/manager/dto/response/PackageResponse';
import {Package} from '../../models/comons/entities/Package';
import {ActivationModelRequest} from '../../models/comons/dto/ActivationModelRequest';
import {Configuration} from '../../configuration';


const customPreRoute = 'uaa';

@Injectable({
    providedIn: 'root'
})
export class PackageService extends BaseService {


    constructor(private http: HttpClient) {
        super('manager');
    }

    getAllSystemPackage(page: number = 0, size: number = 10):
        Observable<ResponseModel<Package[]>> {
        return this.http.get<ResponseModel<Package[]>>
        (`${Configuration.url}/${this.preRoute}/api/general/package?page=${page}&size=${size}`);
    }

    /** infinite scroll stop on size list.length < size **/
    getUserAllPackage(page: number = 0, size: number = 10):
        Observable<ResponseModel<PackageResponse[]>> {
        return this.http.get<ResponseModel<PackageResponse[]>>
        (`${Configuration.url}/${this.preRoute}/api/pv/package?page=${page}&size=${size}`);
    }

    getUserPackageById(id: string): Observable<ResponseModel<Package>> {
        return this.http.get<ResponseModel<Package>>
        (`${Configuration.url}/${this.preRoute}/api/pv/package/${id}`);
    }

    activate(request: ActivationModelRequest): Observable<ResponseModel<void>> {
        return this.http.post<ResponseModel<void>>
        (`${Configuration.url}/uaa/api/activation`, request);
    }
}
